<script setup>
import { onBeforeUnmount, onMounted, shallowRef } from 'vue';

const showModal = shallowRef(false);

onMounted(() => {
  window.addEventListener('keydown', keyListener);
  document.addEventListener('InteractiveActionOverlapHint', interactiveActionOverlapHintListener, { once: true });
});


onBeforeUnmount(() => {
  window.removeEventListener('keydown', keyListener);
  document.removeEventListener('InteractiveActionOverlapHint', interactiveActionOverlapHintListener);
});

function keyListener(event) {
  if (event.keyCode === 69) {
    showModal.value = false;
  }
}


function interactiveActionOverlapHintListener({ detail }) {
  showModal.value = detail;
}
</script>


<template>
  <Transition name="fade">
    <div v-if="showModal" class="shell">
      <div class="modal">
        <div class="modal-content">
          <div class="caption">
            <p class="title fw-7">Как взаимодействовать с экранами в коридоре:</p>
            <button class="close" @click="showModal = false">
              <img src="@/assets/new-icons/close-round.svg" alt="" class="close__img">
            </button>
          </div>
          <p class="fill text">
            Исследуйте интерактивный таймлайн, посвящённый истории Рунета, и сравните, как менялись московские сервисы.
            В
            зоне «Цифровые технологии Москвы. К 30-летию Рунета» вы сможете взаимодействовать с экранами, расположенными
            на стенах коридора.
            <br> 
            <span class="fw-7 fill__content desk">Для управления наведите курсор
              <span class="icon-wrapper">
                <svg class="icon" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M9 4.5C8.46328 4.5 8.46328 5.17512 8.46328 5.17512V10.5172C8.46454 10.5425 8.46454 10.5679 8.46328 10.5931V14.9086C8.46328 15.3126 8.14717 15.6401 7.75724 15.6401C7.3673 15.6401 7.0512 15.3126 7.0512 14.9086V12.2664C6.85629 12.4691 6.67048 12.6673 6.5 12.8542C6.25069 13.1274 6.30902 13.3713 6.15123 13.5656C6.07217 13.6629 6.01055 13.7432 5.96616 13.8053C5.92511 13.8627 5.91088 13.8876 5.91088 13.8876C5.91088 13.8876 5.91142 13.8864 5.91253 13.884C5.8998 13.9107 5.8855 13.9365 5.86973 13.9614C5.48102 14.5742 5.396 14.8961 5.41442 15.1814C5.43575 15.5118 5.6017 15.937 6.06785 16.7438C6.64661 17.7304 7.26709 18.6899 7.92748 19.6198C8.08255 19.8028 8.19335 19.9423 8.28211 20.0543C8.37695 20.1739 8.43414 20.246 8.4968 20.3155C8.61092 20.4422 8.76276 20.5821 9.20632 20.9199C9.79786 21.3401 11.2546 21.7801 15.1888 21.3771C16.5793 21.1493 17.4056 20.4232 17.8988 19.6198C18.4103 18.7866 18.5726 17.8501 18.5656 17.2704L18.5654 17.2612L18.5655 13.8083C18.5655 13.7906 18.5661 13.7729 18.5674 13.7553C18.6638 12.3818 18.4076 11.9652 18.1717 11.7744C18.024 11.6549 17.802 11.5539 17.446 11.4681C17.3578 11.4468 17.2655 11.4274 17.1685 11.409V12.5032C17.1685 12.9073 16.8524 13.2348 16.4624 13.2348C16.0725 13.2348 15.7564 12.9073 15.7564 12.5032V11.4123C15.7138 10.8118 15.2862 10.4354 14.7814 10.3063C14.5951 10.2587 14.4459 10.2594 14.3495 10.2749C14.3599 10.3689 14.3647 10.4634 14.3641 10.5582V11.5308C14.3641 11.9348 14.048 12.2623 13.6581 12.2623C13.2681 12.2623 12.952 11.9348 12.952 11.5308V10.5493C12.9523 10.5157 12.9508 10.483 12.9476 10.4511C12.941 10.4189 12.9354 10.3865 12.9306 10.354C12.8004 9.81268 12.1677 9.50115 11.8031 9.38462C11.5358 9.29923 11.1016 9.33161 11.0009 9.37795V11.5347C11.0009 11.9387 10.6848 12.2662 10.2949 12.2662C9.90497 12.2662 9.58886 11.9387 9.58886 11.5347V9.11091C9.58824 9.09828 9.58792 9.08558 9.58792 9.07279V5.17512C9.58792 5.17512 9.58792 4.5 9 4.5ZM11 7.88573V5.17512C11 3.9804 10.1706 3 9 3C7.85361 3 7.0512 3.95638 7.0512 5.17512V10.2341C6.4926 10.7695 6.2022 11.3472 5.74431 11.849C5.48363 12.1347 5.25183 12.4006 5.07078 12.6236C4.92249 12.8062 4.76496 13.0113 4.67143 13.1867C4.2365 13.8779 3.9568 14.5248 4.00549 15.279C4.05192 15.9983 4.39452 16.6963 4.85755 17.4975L4.85996 17.5017C5.4661 18.535 6.11636 19.5398 6.8088 20.5132C6.821 20.5303 6.83392 20.5469 6.84751 20.5629C6.99687 20.7384 7.10105 20.8695 7.19087 20.9828L7.20329 20.9985C7.28675 21.1038 7.3701 21.209 7.46456 21.3139C7.67333 21.5456 7.91475 21.7524 8.37886 22.1055L8.39437 22.117C9.44075 22.8689 11.3715 23.2403 15.348 22.831C15.3607 22.8297 15.3734 22.828 15.386 22.826C17.2199 22.5325 18.3936 21.5399 19.0903 20.405C19.7695 19.2986 19.9866 18.0758 19.9776 17.2568V13.8344C20.0781 12.3522 19.8538 11.2787 19.0405 10.621C18.6611 10.3142 18.2121 10.1506 17.7661 10.0431C17.4122 9.95776 17.0178 9.89871 16.6121 9.84324C16.2064 9.33173 15.6401 9.01896 15.1198 8.88587C14.6899 8.77591 14.2093 8.76326 13.7948 8.91694C13.4424 8.45232 12.9724 8.14078 12.4896 7.98651C12.1958 7.89263 11.3306 7.85052 11 7.88573Z"
                    fill="white" />
                  <path
                    d="M11.6667 5C11.6667 3.52724 10.4728 2.33333 9 2.33333C7.52724 2.33333 6.33333 3.52724 6.33333 5C6.33333 5.35363 6.40217 5.69119 6.52717 6V8.14428C5.59715 7.41185 5 6.27566 5 5C5 2.79086 6.79086 1 9 1C11.2091 1 13 2.79086 13 5C13 6.27566 12.4028 7.41185 11.4728 8.14428V6C11.5978 5.69119 11.6667 5.35363 11.6667 5Z"
                    fill="white" />
                </svg>
              </span>на интересующий экран и <span class="red"> нажмите
                E.</span></span>
              <span class="fw-7 fill__content mob">Для управления нажмите
                <span class="icon-wrapper">
                  <span class="icon">E
                  </span>
                    
                </span>
              </span>
          </p>
              <button class="link-default" @click="showModal = false">Закрыть</button>
        </div>
      </div>
    </div>

  </Transition>
</template>

<style scoped lang="scss">
.shell {
  pointer-events: none;
  background: none;
}

.modal {
  padding: 0;
  max-width: 720px;
  border-radius: 40px;
  pointer-events: all;
  backdrop-filter: blur(8px);
  background: rgba(157, 196, 248, 0.3);
  padding: 24px;
  width: 100%;


  &-content {
    background: #fff;
    border-radius: 24px;
    padding: 24px;
  }
}
.title{
  font-weight: 700;
font-size: 24px;
letter-spacing: -0.01em;
color: #000;
}
.text {
  margin-top: 6px;
font-weight: 500;
font-size: 20px;
  letter-spacing: -0.01em;
  line-height: 140%;
  color: #000;
}

.fw-7 {
  font-weight: 700;
}

.icon {
  padding: 4px;
  width: 32px;
  height: 32px;
  justify-content: center;
  background: #4c6fc0;
  border-radius: 100%;
  

  &-wrapper {
    border-radius: 100%;
    background: rgba(157, 196, 248, 0.3);
    backdrop-filter: blur(8px);
    padding: 4px;
    display: inline-flex;
    flex-shrink: 0;
    width: 40px;
    height: 40px;
    align-items: center;
    justify-content: center;
    position: relative;
    top: 10px;
    margin-right: 2px;
  }
}

.caption {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.close {
  display: flex;
  width: 32px;
  height: 32px;
  transition: all .5s ease-in-out;

  &:hover {
    opacity: 0.5;
  }

  img {
    width: 100%;
  }
}

.red {
  color: #b72025;
}
.link-default{
  margin-top: 16px;
}

@media (max-width:1300px) {
  .title{
    font-size: 20px;
  }
  .text {
    font-size: 16px;
  }

  .icon {
    padding: 4px;
    width: 28px;
    height: 28px;
    display: flex;
    color: white;

    &-wrapper {
      top: 0;
      padding: 2px;
      width: 34px;
      height: 34px;
    }
  }
}
@media (max-width:1000px) {
  .modal{
    scale: 0.6;
  }
}

.desk {
  @media (max-width: 1000px) {
    display: none !important;
  }
}

.mob {
  display: none !important;
  @media (max-width: 1000px) {
    display: inherit !important;
  }
}
</style>
